module.exports = __webpack_public_path__ + "static/media/footer-logo-academy.212362f8.webp";